import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MenuItem, Select } from "@mui/material";
import React from "react";
import instance from "../../utils/axios";
import { getApiUrl, getReportApiUrl } from "../../utils/apiUrls";
import { ReactComponent as EmptyData } from "../../assets/images/global/empty-data.svg";
import { openSnackBar } from "../../redux/actions/snackbar.actions";
import { useDispatch, useSelector } from "react-redux";
import { apiErrorHandler } from "../../utils/errorHandler";
import { useNavigate, useSearchParams } from "react-router-dom";
import { saveAs } from "file-saver";
import ProgressBar from "../../components/progress-bar/ProgressBar.component";
import axios from "axios";
import CustomToolTip from "../../components/custom-tooltip/CustomTooltip.component";
import { isSecureUrl } from "../../utils/helperFn";

const dataPerPage = 12;
const taskDownloadAbleReport = ["FEEDBACK_SURVEY", "HOGAN_ASSESSMENTS"];
const CandidateReport = ({ t }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const [searchParams] = useSearchParams();
  const currentEventId = searchParams.get("eventId");
  const currentReportType = searchParams.get("reportType"); // TASK EVENT
  const appSettings = useSelector((state) => state.appSettings);
  const [formVal, setFormVal] = React.useState({
    tabValue: currentReportType,
    isLoading: false,
    paginationIsLoading: false,
    tabBarIsLoading: false,
    reportIsLoading: false,
    isDownloadingreportIsLoading: false,
    totalEventCount: null,
    eventData: null,
    toViewData: null,
    dropDownPageNum: 0,
    currentPageNum: 0,
    totalEventReportCount: null,
    totalTaskReportCount: null,
  });
  const paginationNextFlag = React.useMemo(() => {
    return (
      formVal.tabBarIsLoading ||
      formVal.isLoading ||
      (formVal.tabValue === "EVENT"
        ? formVal.totalEventReportCount
        : formVal.totalTaskReportCount) <=
        (formVal.currentPageNum + 1) * dataPerPage
    );
  }, [
    formVal.totalTaskReportCount,
    formVal.totalEventReportCount,
    formVal.isLoading,
    formVal.tabValue,
    formVal.currentPageNum,
  ]);
  const paginationPreviousFlag = React.useMemo(() => {
    return (
      formVal.tabBarIsLoading ||
      formVal.isLoading ||
      formVal?.currentPageNum > 0
    );
  }, [formVal.isLoading, formVal.currentPageNum]);
  const envState = useSelector((state) => state.env);
  const fetchReportData = async (
    level = "EVENT",
    eventId = currentEventId,
    pageNo = 0,
    actionType
  ) => {
    try {
      if (formVal.isLoading || formVal.tabBarIsLoading) return;
      let tempObj = {};
      if (
        level !== formVal.tabValue ||
        (actionType === "isLoading" && !!eventId)
      ) {
        // CONDITION 1 FROM URL CHANGE WHEN TAB IS CHANGED
        // CONDITION 2 FROM USEFFECT
        tempObj = { tabBarIsLoading: true };
      } else if (actionType === "paginationIsLoading") {
        tempObj = { paginationIsLoading: true };
      }
      setFormVal({
        ...formVal,
        ...tempObj,
      });
      let currentForValData = { ...formVal };
      const token = localStorage.getItem("token");
      if (!(formVal.eventData?.length > 0)) {
        // EVENT DATA (RENDER ONCE)
        // await instance.get(
        //   `${getApiUrl("getEventNameListForCandidate")}?pageNumber=${
        //     formVal.dropDownPageNum
        //   }&pageSize=${dataPerPageEvent}`
        const eventsData = await instance.get(
          `${getApiUrl("getEventNameListForCandidate")}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!!eventsData.data) {
          currentForValData = {
            ...currentForValData,
            dropDownPageNum: formVal.dropDownPageNum + 1,
            totalEventCount: eventsData?.data?.totalNumber,
            eventData: eventsData.data.reportConfigDtos,
            tabValue: !!level ? level : "EVENT",
            isLoading: !!eventId,
          };
          setFormVal(currentForValData);
          if (!eventId) return; // NO EVENT SELECTED
        }
      }

      if (!eventId) {
        throw Error("empty_event_id");
      }
      setFormVal({
        ...formVal,
        isLoading: false,
        ...tempObj,
      });
      // REPORT DATA (ON EVERY EVENT CHANGE)
      let reportData = await instance.get(
        `${getApiUrl(
          "getCandidateEventTaskReport"
        )}/${eventId}?pageSize=${dataPerPage}&pageNumber=${pageNo}&candidateId=${
          user.userId
        }&reportType=${!!level ? level : currentForValData.tabValue}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Process grouped Hogan tasks
      if (reportData.data?.taskDetailsDtoList && reportData.data?.taskDetailsDtoList?.length > 0) {
        const groupedHoganTasks = reportData.data.taskDetailsDtoList.filter(task => task.groupedHoganTask === true);
        
        // Check if any grouped Hogan task is not completed
        const hasIncompleteTask = groupedHoganTasks.some(task => task.taskStatus !== "COMPLETED");
        
        // If at least one is incomplete, set all grouped tasks to YET_TO_START
        if (hasIncompleteTask) {
          reportData.data.taskDetailsDtoList = reportData.data.taskDetailsDtoList.map(task => {
            if (task.groupedHoganTask === true) {
              return { ...task, taskStatus: "YET_TO_START" };
            }
            return task;
          });
        }
      }

      if (level === "EVENT") {
        currentForValData = {
          ...currentForValData,
          paginationIsLoading: false,
          totalEventReportCount: reportData.data.totalEventReportCount,
          totalTaskReportCount: reportData.data.totalTaskReportCount,
          toViewData: reportData.data.reportDetailsDtoList,
          reportType: reportData.data.reportDetailsDtoList?.length > 0 ? reportData.data.reportDetailsDtoList[0].reportType : null,
          currentPageNum: level === "EVENT" ? pageNo : 0,
        };
      } else {
        currentForValData = {
          ...currentForValData,
          paginationIsLoading: false,
          toViewData: reportData.data.taskDetailsDtoList,
          totalEventReportCount: reportData.data.totalEventReportCount,
          totalTaskReportCount: reportData.data.totalTaskReportCount,
          currentPageNum: level === "TASK" ? pageNo : 0,
          reportType: null,
        };
      }
      if (!!reportData.data) {
        setFormVal({
          ...currentForValData,
          tabValue: !!level ? level : formVal.tabValue,
          isLoading: false,
          paginationIsLoading: false,
          tabBarIsLoading: false,
        });
      }
    } catch (error) {
      setFormVal({
        ...formVal,
        isLoading: false,
        paginationIsLoading: false,
        tabBarIsLoading: false,
      });
      const errObj = apiErrorHandler(error);
      if (errObj.statusText === "empty_event_id") {
        return;
      }
      dispatch(
        openSnackBar({
          msg: t(errObj.statusText),
          type: "error",
        })
      );
    }
  };
  const getReportKey = async (reportId) => {
    try {
      if (!currentEventId) {
        return;
      }
      const res = await instance.get(
        `${getReportApiUrl("getReportKey")}/${currentEventId}/${user.userId}/true?${
          !!reportId
            ? `reportConfigurationId=${reportId}`
            : ``
        }`
      );
      if (!!res.data) {
        const mainUrl =
          window.location.hostname === "localhost" ||
          window.location.hostname === "127.0.0.1"
            ? `http://localhost:3001`
            : `https://${envState.METTL_URL}`;
        const reportUrl = formVal?.reportType === "COMMON" ? `https://${envState?.METTL_URL}/analytics/share-report?versionId=${reportId}&key=${res.data}&vscReport=true` : `${mainUrl}/vadcadmin/report?key=${res.data}&lang=${
          appSettings?.lang ? appSettings?.lang : "en"
        }`;
        
        // Security: Validate URL to prevent Open Redirect (CWE-601)
        const secureUrl = isSecureUrl(reportUrl, dispatch, t);
        if (!secureUrl) return;
        
        // Safe: URL has been validated above
        window.open(secureUrl, "_blank");
      }
    } catch (error) {
      const msgObj = apiErrorHandler(error);
      dispatch(
        openSnackBar({
          msg: t(msgObj.statusText),
          type: "error",
        })
      );
    }
  };
  React.useEffect(() => {
    if (!!currentReportType)
      fetchReportData(currentReportType, currentEventId, 0, "isLoading");
  }, [currentEventId, currentReportType]);
  const loadSelectOptions = () => {
    if (formVal?.eventData?.length > 0) {
      return formVal.eventData?.map((el) => (
        <MenuItem
          value={el.eventId}
          key={el.eventId}
          style={{ width: "250px" }}
          className="d-flex align-items-center fw-medium cm-sm-txt text-blue-800"
        >
          <span className="cm-truncate-1">{el.eventName}</span>
        </MenuItem>
      ));
    } else {
      return null;
    }
  };
  const handlerDownloadReport = async (taskId, taskName, taskType) => {
    try {
      if (formVal.isDownloadingreportIsLoading) return;
      setFormVal({
        ...formVal,
        isDownloadingreportIsLoading: true,
      });
      const token = localStorage.getItem("token");

      let reportData, candidateName = `${user.firstName}_${user?.lastName ? user.lastName : ""}`;
      if (taskType === "HOGAN") {
        reportData = await instance.get(
          `${getApiUrl(
            "downloadCandidateTaskReport"
          )}?eventId=${currentEventId}&taskId=${taskId}&candidateId=${
            user.userId
          }`,
          {
            responseType: "blob",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        reportData = await axios.post(
          `https://${envState?.METTL_URL}/360feedback/survey-api/single-report-pdf-download`,
          {
            fileDataList: [
              {
                printMedia: false,
                url: taskId,
              },
            ],
            pdfName: candidateName + ".pdf",
          },
          {
            responseType: "blob",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (!!reportData.data) {
        const blob = new Blob([reportData.data], { type: "application/pdf" });
        let fileName;
        if (taskType === "HOGAN") {
          fileName = `${candidateName}_${t(taskName)}.pdf`;
        } else {
          fileName = candidateName + ".pdf";
        }
        saveAs(blob, fileName);
      }
      setFormVal({
        ...formVal,
        isDownloadingreportIsLoading: false,
      });
    } catch (err) {
      setFormVal({
        ...formVal,
        isDownloadingreportIsLoading: false,
      });
      const errorMes = new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onload = () => {
          err.response.data = JSON.parse(reader.result);
          const msgObj = apiErrorHandler(err);
          dispatch(
            openSnackBar({
              msg: t(msgObj.statusText),
              type: "error",
            })
          );
          resolve(Promise.reject(err));
        };

        reader.onerror = () => {
          reject(err);
        };
        reader.readAsText(err.response.data);
      });
    }
  };
  const handlerVerifyFn = async (val, actionType) => {
    // ONLY FOR TASK REPORT
    if (formVal.reportIsLoading) return;
    setFormVal({
      ...formVal,
      reportIsLoading: true,
    });
    try {
      const eventId = !!currentEventId ? currentEventId : currentEventId;
      const res = await instance.get(
        `${getApiUrl(
          "validateViewDownloadCandidateTaskReport"
        )}?eventId=${eventId}&taskId=${val.taskId}&actionType=${actionType}`
      );
      if (res.data) {
        if (
          taskDownloadAbleReport.includes(val.taskType) ||
          taskDownloadAbleReport.includes(val.modeType)
        ) {
          const taskType = val.modeType === "HOGAN_ASSESSMENTS" ? "HOGAN" : "SURVEY";
          handlerDownloadReport(taskType === "HOGAN" ? val.taskId : val?.reportLink, val.taskName, taskType);
        } else {
          if (!!val?.reportLink && !"?key=null".includes(val.reportLink)) {
            // Security: Validate URL to prevent Open Redirect (CWE-601)
            const secureUrl = isSecureUrl(val.reportLink, dispatch, t);
            if (!secureUrl) return;
            // Safe: URL has been validated above
            window.open(secureUrl, "_blank");
          }
        }
      } else {
        throw Error("unauthorized_access");
      }
      setFormVal({
        ...formVal,
        reportIsLoading: false,
      });
    } catch (error) {
      setFormVal({
        ...formVal,
        reportIsLoading: false,
      });
      const msgObj = apiErrorHandler(error);
      dispatch(
        openSnackBar({
          msg: t(msgObj.statusText),
          type: "error",
        })
      );
    }
  };
  const viewText = (val) => {
    if (
      formVal.tabValue === "TASK" &&
      (taskDownloadAbleReport.includes(val?.taskType) ||
        taskDownloadAbleReport.includes(val?.modeType))
    ) {
      return "download_report";
    }
    return "view_report";
  };
  const loadMoreItems = async (event, index) => {
    if (
      !formVal.isLoading &&
      formVal.eventData?.length < Number(formVal.totalEventCount) &&
      Math.abs(
        event.target.scrollHeight -
          event.target.clientHeight -
          event.target.scrollTop
      ) < 1
    ) {
      try {
        setFormVal({
          ...formVal,
          isLoading: true,
        });
        const token = localStorage.getItem("token");
        const eventsData = await instance.get(
          `${getApiUrl("getEventNameListForCandidate")}?pageNumber=${
            formVal.dropDownPageNum
          }&pageSize=${dataPerPage}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setFormVal({
          ...formVal,
          isLoading: false,
          dropDownPageNum: formVal.dropDownPageNum + 1,
          totalEventCount: eventsData.data.totalNumber,
          eventData: [
            ...formVal.eventData,
            ...eventsData.data.reportConfigDtos,
          ],
          currentSelectedEventId: Number(currentEventId),
        });
      } catch (error) {
        setFormVal({
          ...formVal,
          isLoading: false,
        });
        const errObj = apiErrorHandler(error);
        dispatch(
          openSnackBar({
            msg: t(errObj.statusText),
            type: "error",
          })
        );
      }
    }
  };

  const handleTaskLinkEnable = React.useCallback((el) => {
    if (formVal.tabValue !== "TASK") {
      return "text-action-1 cm-pointer";
    }

    const isDownloadableTask = taskDownloadAbleReport.includes(el.modeType);
    const hasInvalidReportLink = !el.reportLink || el.reportLink.includes("?key=null");
    const taskStatus = el.taskStatus;
    const isFeedbackSurvey = el.taskType === "FEEDBACK_SURVEY";

    if (taskStatus !== "COMPLETED") {
      return "text-blue-gray-700 cm-btn-disabled";
    }

    if (hasInvalidReportLink && (!isDownloadableTask || isFeedbackSurvey)) {
      return "text-blue-gray-700 cm-btn-disabled";
    }

    return "text-action-1 cm-pointer";
  }, [formVal.tabValue]);

  const renderName = (el) => {
    if(formVal.tabValue !== "TASK") {
      return el.configType === "DEFAULT" ? t(el.reportName) : el.reportName;
    }
    return ["TTE_ASSESSMENTS", "HOGAN_ASSESSMENTS"].includes(el.modeType) ? t(el.taskName) : el.taskName;
  }

  const pageBodyComponent = () => {
    return formVal.toViewData?.length > 0 ? (
      <div className="border border-blue-gray-100 cm-btn-radius">
        <div
          className="cm-candidate-report-list-header d-flex align-items-center bg-blue-gray-50 border-bottom"
          style={{
            minHeight: "62px",
            borderTopLeftRadius: "4px",
            borderTopRightRadius: "4px",
          }}
        >
          <div className="col-sm-1 d-flex align-items-center">
            <p className="my-0 ps-32 cm-sm-txt fw-medium text-blue-gray-700">
              {t("sno")}
            </p>
          </div>
          <div className="col-sm-8 ps-32">
            <p className="my-0 cm-sm-txt fw-medium text-blue-gray-700">
              {t("report_name")}
            </p>
          </div>
          <div className="col-sm-3 ps-32">
            <p className="my-0 cm-sm-txt fw-medium text-blue-gray-700">
              {t("actions")}
            </p>
          </div>
        </div>
        {!formVal.paginationIsLoading ? (
          <div
            className="bg-white border-blue-gray-100 overflow-auto"
            style={{ maxHeight: "400px" }}
          >
            {formVal.toViewData.map((el, index) => {
              const btnClasses = handleTaskLinkEnable(el);
              const isBtnDisabled = btnClasses.includes("cm-btn-disabled");

              const viewTextString = viewText(el);

              return (
                <div
                  className={`d-flex py-3 ${
                    index ? "border-top border-blue-gray-100" : ""
                  }`}
                  key={index}
                >
                  <div className="col-sm-1 d-flex align-items-center">
                    <p className="my-0 ps-32 py-1 cm-sm-txt fw-medium text-blue-gray-700">
                      {formVal?.currentPageNum * dataPerPage +
                        Number(index) +
                        1}
                    </p>
                  </div>
                  <div className="col-sm-8 py-1">
                    <p className="mb-1 ps-32 cm-sm-txt fw-medium text-blue-gray-700 text-break">
                      {renderName(el)}
                      {/* {" / "}
                      {taskDownloadAbleReport.includes(el.modeType)
                        ? t(el.modeType.toLowerCase())
                        : t(el.taskType.toLowerCase())} */}
                    </p>
                    {el.modeType === "TTE_ASSESSMENTS" && el?.reportName && <p className="mb-0 ps-32 cm-xs-txt text-blue-gray-700 mt-1 fw-medium">{t("report_name")}: <span className="text-blue-500">{t(el.reportName)}</span></p>}
                  </div>
                  <div className="col-sm-3 py-1 my-auto ps-32">
                    <CustomToolTip disableTooltip={(formVal.tabValue === "TASK" && !isBtnDisabled) || formVal.tabValue === "EVENT"} title={t("view_report_unavailable_cand_not_attempted_task")} >
                      <p
                        className={`my-0 text-decoration-underline cm-sm-txt fw-medium d-inline-block ${btnClasses} `}
                        onClick={() => {
                          if(!isBtnDisabled) {
                            formVal.tabValue === "EVENT"
                              ? getReportKey(el.reportId)
                              : handlerVerifyFn(el, viewTextString === "download_report" ? "TASK_REPORT_DOWNLOAD" : "TASK_REPORT_VIEW");
                          }
                        }}
                      >
                        {t(viewTextString)}
                      </p>
                    </CustomToolTip>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "300px" }}
          >
            <ProgressBar />
          </div>
        )}
        <div
          className="cm-event-pagination-container border-top py-12 border-blue-gray-100 bg-blue-gray-50 px-32 d-flex align-items-center justify-content-between"
          style={{
            borderBottomLeftRadius: "4px",
            borderTopRightRadius: "4px",
          }}
        >
          <div className="cm-event-page-info text-blue-gray-700 cm-sm-txt">
            {t("page")}{" "}
            <span className="fw-medium">
              {formVal.currentPageNum + 1} {" " + t("of") + " "}
              {Math.ceil(
                (formVal.tabValue === "TASK"
                  ? Number(formVal.totalTaskReportCount)
                  : Number(formVal.totalEventReportCount)) / dataPerPage
              )}
            </span>
          </div>
          <div className="cm-event-page-controls d-flex align-items-center justify-content-end">
            <span
              className={`cm-event-page-btn px-3 py-2 cm-btn-radius border border-blue-gray-300 bg-white cm-sm-txt fw-medium d-inline-block text-blue-800 cm-light-hover ${
                !paginationPreviousFlag ? "cm-pagin-disable" : "cm-pointer"
              }`}
              onClick={() => {
                paginationPreviousFlag &&
                  fetchReportData(
                    formVal.tabValue,
                    currentEventId,
                    formVal.currentPageNum - 1,
                    "paginationIsLoading"
                  );
              }}
            >
              {t("previous")}
            </span>
            <span
              className={`cm-event-page-btn px-3 py-2 cm-btn-radius border border-blue-gray-300 bg-white cm-sm-txt fw-medium ms-2 d-inline-block text-blue-800 cm-light-hover ${
                paginationNextFlag ? "cm-pagin-disable" : "cm-pointer"
              }`}
              onClick={() => {
                !paginationNextFlag &&
                  fetchReportData(
                    formVal.tabValue,
                    currentEventId,
                    formVal.currentPageNum + 1,
                    "paginationIsLoading"
                  );
              }}
            >
              {t("next")}
            </span>
          </div>
        </div>
      </div>
    ) : (
      <div
        className="cm-empty-wrapper bg-blue-gray-50 d-flex flex-column justify-content-center align-items-center cm-empty-invite-container py-5 text-center"
        style={{ height: "300px" }}
      >
        <div className="cm-content">
          <EmptyData />
          <p className="fw-semibold mb-2 text-blue-700 my-0">
            {t("nothing_to_see")}
          </p>
          <p
            className="mb-3 cm-sm-txt text-blue-gray-500 fw-medium"
            style={{ maxWidth: "368px" }}
          >
            {t("reports_candidates_participated")}
          </p>
        </div>
      </div>
    );
  };
  const tabBarComponent = React.useCallback(() => {
    return (
      <div className="my-2 d-flex cm-sm-txt">
        <p
          className={`rounded-start border border-blue-gray-300 border-end-0 px-3 py-10 ${
            formVal.tabValue === "EVENT"
              ? "text-white bg-action-blue border-blue-500"
              : ""
          } ${
            formVal.tabValue === "EVENT" || !currentEventId ? "" : "cm-pointer"
          }`}
          onClick={() => {
            if (formVal.tabValue === "EVENT" || !currentEventId) return;
            navigate(
              `/candidate-report?eventId=${currentEventId}&reportType=EVENT`,
              { replace: true }
            );
          }}
        >
          {t("event_report_s")}
        </p>
        <p
          className={`rounded-end border border-blue-gray-300  px-3 py-10 ${
            formVal.tabValue === "TASK"
              ? "text-white bg-action-blue border-blue-500"
              : ""
          } ${
            formVal.tabValue === "TASK" || !currentEventId ? "" : "cm-pointer"
          }`}
          onClick={() => {
            if (formVal.tabValue === "TASK" || !currentEventId) return;
            navigate(
              `/candidate-report?eventId=${currentEventId}&reportType=TASK`,
              {
                replace: true,
              }
            );
          }}
        >
          {t("task_report_s")}
        </p>
      </div>
    );
  }, [t, formVal, currentEventId]);
  const eventDropDownComponent = () => {
    return (
      <div
        className="position-relative ms-auto my-auto"
        style={{ width: "250px" }}
      >
        <Select
          labelId="candiateReportLabel"
          id="candiateReport"
          displayEmpty={true}
          value={currentEventId || ""}
          onChange={(e) => {
            navigate(
              `/candidate-report?eventId=${e.target.value}&reportType=${formVal.tabValue}`,
              { replace: true }
            );
          }}
          fullWidth={true}
          className="bg-white cm-sm-txt fw-medium text-blue-800 cm-select-field"
          MenuProps={{
            className:
              "cm-select-modal cm-select-inside-modal cm-cohort-select-modal",
            PaperProps: {
              onScroll: (e) => loadMoreItems(e),
            },
          }}
          renderValue={(selected) => {
            const selectedEvent = formVal.eventData.find(
              (el) => Number(el.eventId) === Number(selected)
            )?.eventName;
            return !!selectedEvent ? selectedEvent : t("select_event");
          }}
        >
          {loadSelectOptions()}
        </Select>
        <FontAwesomeIcon
          icon={regular("chevron-down")}
          className="cm-select-arrow cm-sm-txt text-blue-gray-500 position-absolute"
        />
      </div>
    );
  };
  return (
    <div className="mx-40 mb-40 mt-4">
      <div className="d-flex border-bottom pb-4 mb-4 border-blue-gray-200">
        <div>
          <p className="mb-0 h4 text-blue-800 cm-mmc-font">
            {t("view_reports")}
          </p>
          <p className="mb-0 text-blue-gray-500 mt-2 fw-medium text-break">
            {t("please_select_the_event_name_first")}
          </p>
        </div>
        {formVal?.eventData?.length > 0 && eventDropDownComponent()}
      </div>
      {!formVal.isLoading && (
        <>
          {tabBarComponent()}
          {!formVal.tabBarIsLoading ? (
            pageBodyComponent()
          ) : (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "calc(50vh - 10px)" }}
            >
              <ProgressBar />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CandidateReport;
